export default "__VITE_ASSET__BbErHX6___"